import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

import { runtimeEnv } from '../utils/runtimeEnv';

export function useSafeLogout() {
  const { logout } = useAuth0();
  const navigate = useNavigate();

  return function safeLogout() {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = `https://${runtimeEnv.auth0Domain}/v2/logout?client_id=${runtimeEnv.auth0ClientId}`;
    document.body.appendChild(iframe);

    logout({ openUrl: false })
      .catch(() => {})
      .finally(() => setTimeout(() => document.body.removeChild(iframe), 500));

    navigate(0);
  };
}
